(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.Style = factory());
})(this, (function () { 'use strict';

    class StyleUtil {
        constructor(config) {
            /*
             * The order matters for priority in detecting themes
             * (dynamic can be applied in combination with dark or light)
             */
            this.themes = ['dynamic', 'dark', 'light'];
            this._listeners = [];
            this._config = {
                rootElem: config.rootElem || document.body,
            };
        }
        initColorSchemeListener() {
            const matchMediaList = window.matchMedia('(prefers-color-scheme: dark)');
            if (!matchMediaList.addEventListener && matchMediaList.addListener) {
                matchMediaList.addListener(() => {
                    if (this.getRawTheme() === 'dynamic') {
                        this.setTheme('dynamic');
                    }
                });
            }
            else {
                matchMediaList.addEventListener('change', () => {
                    if (this.getRawTheme() === 'dynamic') {
                        this.setTheme('dynamic');
                    }
                });
            }
        }
        setTheme(theme) {
            if (!theme || !this.themes.includes(theme)) {
                return;
            }
            const oldtheme = this.getAppliedTheme();
            for (const t of this.themes) {
                this._config.rootElem.classList.remove(`is-${t}`);
            }
            if (theme === 'dynamic') {
                if (!this._config.rootElem.classList.contains('is-dynamic')) {
                    this._config.rootElem.classList.add('is-dynamic');
                }
                const colorScheme = this.getPreferColorScheme();
                this._config.rootElem.classList.add(`is-${colorScheme}`);
            }
            else {
                this._config.rootElem.classList.add(`is-${theme}`);
            }
            const newTheme = this.getAppliedTheme();
            if (newTheme === oldtheme) {
                return;
            }
            for (const cb of this._listeners) {
                if (cb) {
                    cb(newTheme);
                }
            }
        }
        getPreferColorScheme() {
            if (window.matchMedia
                && window.matchMedia('(prefers-color-scheme: dark)').matches) {
                return 'dark';
            }
            return 'light';
        }
        getRawTheme() {
            let theme;
            for (const t of this.themes) {
                if (this._config.rootElem.classList.contains(`is-${t}`)) {
                    theme = t;
                    break;
                }
            }
            return theme;
        }
        getAppliedTheme() {
            const theme = this.getRawTheme();
            switch (theme) {
                case 'dynamic':
                    if (this._config.rootElem.classList.contains('is-dark')) {
                        return 'dark';
                    }
                    return 'light';
                case 'dark':
                    return 'dark';
                default:
                    return 'light';
            }
        }
        addThemeListener(cb) {
            // Return index
            return this._listeners.push(cb) - 1;
        }
        removeThemeListener(i) {
            this._listeners[i] = null;
        }
        setStyle(style) {
            this._setStyle(style);
        }
        get(prop) {
            const styles = window.getComputedStyle(this._config.rootElem);
            return styles.getPropertyValue(`--${prop}`);
        }
        _setStyle(style, path = []) {
            for (const prop of Object.keys(style)) {
                const val = style[prop];
                if (val && typeof val === 'object') {
                    this._setStyle(val, [...path, prop]);
                }
                else if (val && typeof val === 'string') {
                    this._writeToDom([...path, prop].join('-'), val);
                }
            }
        }
        _writeToDom(key, val) {
            const elem = document.getElementsByClassName('ot-document')[0];
            elem.style.setProperty(`--ot-${key}`, val);
        }
    }

    return StyleUtil;

}));
